"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_dropzone_1 = require("react-dropzone");
const context_1 = require("../context");
const react_1 = require("react");
const template_parser_1 = require("@osmosys/template-parser");
const lodash_1 = require("lodash");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const useNumber_1 = tslib_1.__importDefault(require("react-hanger/array/useNumber"));
const utils_1 = require("../../../panels/ContentImportPanel/utils");
exports.useEditorViewportEl = () => {
    const { location: { pathname, search, key, hash }, } = use_react_router_1.default();
    const [attempts, actions] = useNumber_1.default(1);
    const el = react_1.useMemo(() => {
        return document.querySelector('#emailCanvasEditorViewScrollContainer');
    }, [pathname, search, key, hash, attempts]);
    react_1.useEffect(() => {
        if (!el) {
            const i = setInterval(() => {
                actions.increase();
            }, 75 * 10);
            return () => {
                clearInterval(i);
            };
        }
        else {
            actions.setValue(0);
            return () => { };
        }
    }, [!!el]);
    return [el, attempts];
};
exports.useBlockUploader = (disabled) => {
    const props = tslib_1.__rest(react_dropzone_1.useDropzone({
        disabled,
        noClick: true,
        noKeyboard: true,
        preventDropOnDocument: true,
    }), []);
    return Object.assign({}, props);
};
exports.useEmailCanvasBlockDetailChangeContext = (throwOnNoContext = true) => {
    const context = react_1.useContext(context_1.EmailCanvasBlockDetailChangeContext);
    if (!context && throwOnNoContext) {
        throw new Error('Missing Block context');
    }
    return context;
};
exports.useEmailCanvasBlockDetailContext = (throwOnNoContext = true) => {
    const context = react_1.useContext(context_1.EmailCanvasBlockDetailContext);
    if (!context && throwOnNoContext) {
        throw new Error('Missing Block context');
    }
    return context;
};
exports.useEmailCanvasBlockMeta = (_a, adminRole, activeContentImportBlockIdx) => {
    var { block } = _a, props = tslib_1.__rest(_a, ["block"]);
    const meta = Object.assign({}, props);
    meta.contentImportIsActive = react_1.useMemo(() => !!activeContentImportBlockIdx &&
        !!lodash_1.isEqual(props.indexPath, activeContentImportBlockIdx), [...props.indexPath, activeContentImportBlockIdx]);
    return react_1.useMemo(() => {
        // TODO USECASES:
        // - [ ] Clearable groups
        // - [ ] Disabling inputs (ads and textarea) when _parent_ is hidden and hideable
        // - [ ] Disabling inputs (ads and textarea) when _parent_ is locked and lockable
        meta.showUploader =
            block.type === 'field' &&
                block.fieldType === 'url' &&
                (block.selectedTargets || []).includes('src');
        /*  LOCK */
        meta.isLocked =
            template_parser_1.emailTemplateBlockIs(block, 'locked') ||
                props.parentIsLocked ||
                props.parentIsHidden;
        meta.isLockable = block.lockable;
        // EDITABLE
        meta.contentCanBeChanged = !meta.isLocked && !block.hidden;
        /*  IS HIGHLIGHTED  */
        meta.isHighlighted = block.type === 'group';
        meta.isHighlightedSecondary = false;
        meta.isHighlightedPrimary = !meta.isHighlightedSecondary;
        /*  CONTENT  */
        meta.hasUserContent = template_parser_1.emailTemplateBlockHas(block, 'userContent');
        meta.hasImportedContent = template_parser_1.emailTemplateBlockHas(block, 'importedContent', true, true);
        meta.value = meta.hasImportedContent
            ? template_parser_1.getEmailTemplateBlockData(block, 'importedContent', true, true)
            : template_parser_1.getEmailTemplateBlockData(block, 'userContent', false, true);
        meta.contentFieldKeyCanBeChanged =
            meta.hasImportedContent && block.type === 'field';
        /*  CONVERSIONS  */
        meta.hasConversions =
            block.type === 'field' &&
                block.fieldType === 'html' &&
                template_parser_1.emailTemplateBlockHas(block, 'conversions');
        meta.canRunConversions =
            !('osys:converter:disabled' in (block.attrs || {})) &&
                block.contentItem &&
                meta.value &&
                meta.hasConversions &&
                meta.contentCanBeChanged;
        /*  CLEARABLE */
        meta.isClearable =
            meta.contentCanBeChanged &&
                !!template_parser_1.emailTemplateBlockHas(block, 'clearable', true, true);
        // emailTemplateBlockIs(block, 'clearable', true)
        /*  DISABLED  */
        meta.isDisabled =
            meta.hasImportedContent ||
                meta.isLocked ||
                (block.parentBlock &&
                    (template_parser_1.emailTemplateBlockIs(block.parentBlock, 'locked') ||
                        template_parser_1.emailTemplateBlockIs(block.parentBlock, 'hidden')));
        /* RELATEDS */
        meta.isChildBlock = !!props.parentBlock;
        meta.hasChildBlocks = block.childBlocks && block.childBlocks.length > 0;
        meta.hasVisibleChildBlocks =
            block.childBlocks &&
                block.childBlocks.filter(b => b.type !== 'social').length > 0;
        meta.hasSocialChildren = !!(block.childBlocks && block.childBlocks.find(b => b.type === 'social'));
        /* META */
        meta.idxPath = props.indexPath.join(':');
        meta.localId = meta.idxPath + ':' + block.clientId;
        meta.displayName = template_parser_1.getEmailTemplateBlockData(block, 'displayName', true, true);
        const [linkToPost] = block.contentItem
            ? utils_1.getContentItemFieldData(block.contentItem, 'link', '')
            : ['', false];
        meta.linkToPost = linkToPost;
        // const canImportContent = !meta.hasImportedContent && !meta.isClearable;
        // const fieldCanImportContent =
        //   canImportContent && ;
        // const groupCanImportContent =
        //   canImportContent &&
        //   block.type === 'group' &&
        //   emailTemplateBlockHas(block, 'contentField', true, true);
        meta.canImportContent =
            !meta.hasImportedContent &&
                !meta.isClearable &&
                template_parser_1.emailTemplateBlockHas(block, 'contentField', true, true);
        meta.canLock =
            !meta.parentIsLocked &&
                !meta.parentIsHidden &&
                adminRole &&
                block.lockable;
        /* OVERLAY */
        const showOverlayBecauseActivelyImportingContent = !!meta.contentImportIsActive;
        const parentHasOverlay = !!(meta.parentIsHidden || meta.parentIsLocked);
        const showOverlayBecauseOfHideOrLock = !!(block.hidden || block.locked);
        meta.showOverlay =
            !parentHasOverlay &&
                (showOverlayBecauseActivelyImportingContent ||
                    showOverlayBecauseOfHideOrLock);
        return meta;
    }, [block, props, adminRole, activeContentImportBlockIdx]);
};
//# sourceMappingURL=index.js.map